import api from './api';

export interface DashboardStats {
  users: {
    total: number;
    active: number;
    new_this_month: number;
    paying: number;
  };
  revenue: {
    monthly: number;
    total: number;
  };
  content: {
    total_posts: number;
    total_media: number;
    posts_this_month: number;
    media_this_month: number;
  };
  ai: {
    total_generations: number;
    active_tasks: number;
  };
}

export interface RecentUser {
  id: string;
  name: string;
  email: string;
  tier: string;
  joined_at: string;
  is_active: boolean;
  credits: number;
}

export interface RecentActivity {
  id: string;
  action: string;
  user: string;
  time_display: string;
  type: string;
}

export interface TierDistribution {
  tier_name: string;
  tier_key: string;
  user_count: number;
  monthly_revenue: number;
}

const adminService = {
  // Dashboard Statistics
  getDashboardStats: async (): Promise<DashboardStats> => {
    const response = await api.get<DashboardStats>('/admin/dashboard/stats');
    return response.data;
  },

  // Recent Users
  getRecentUsers: async (limit: number = 10): Promise<RecentUser[]> => {
    const response = await api.get<RecentUser[]>(`/admin/dashboard/recent-users?limit=${limit}`);
    return response.data;
  },

  // Recent Activity
  getRecentActivity: async (limit: number = 20): Promise<RecentActivity[]> => {
    const response = await api.get<RecentActivity[]>(`/admin/dashboard/recent-activity?limit=${limit}`);
    return response.data;
  },

  // Tier Distribution
  getTierDistribution: async (): Promise<TierDistribution[]> => {
    const response = await api.get<TierDistribution[]>('/admin/dashboard/tier-distribution');
    return response.data;
  },
};

export default adminService;